import { render, staticRenderFns } from "./JobOffersInWork.vue?vue&type=template&id=58c1577c&"
import script from "./JobOffersInWork.vue?vue&type=script&lang=js&"
export * from "./JobOffersInWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports